/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const INDEXFM_LOGO =
  "https://media.werz.at/community/icon/cmcezi4eg0002es9k1d17f7a3?uploadTime=1751233274880&type=image&v=1762238616236"

const indexfm: CommunityData = {
  code: "indexfm",
  inviteCode: "indexfm",
  name: "IndexFM",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ifm-184`,
  socials: {},
  styles: {
    global: {
      mobileOnly: true,
      counterColor: "#ffffff",
      logo: {
        src: INDEXFM_LOGO,
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: INDEXFM_LOGO,
        styles: "w-[96px] h-[96px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#245DDB",
      asideBg: "#245DDB",
      asideStyles: "border-r border-[#ffffff]",
      contentBg: "#245DDB",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: "",
      mainFont: "font-['SegoeUIThis_Regular']",
      primaryButton:
        "bg-[#245DDB] border border-[#ffffff] px-[18px] py-[18px] !text-[#ffffff] font-['SegoeUIThis_Regular'] !text-[16px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r border-[#ffffff]",
      separator: "border-[#ffffff]",
      item: "text-[#ffffff] font-['SegoeUIThis_Regular'] text-[16px] uppercase text-left leading-[100%] text-opacity-60 border-b border-[#ffffff] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#245DDB] border border-[#ffffff] !pb-8",
      titles:
        "text-[#ffffff] font-['SegoeUIThis_Regular'] text-[28px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['SegoeUIThis_Regular'] text-[14px] text-left leading-[120%]",
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0",
        sectionTitle: "hidden",
        title:
          "text-[#ffffff] font-['SegoeUIThis_Regular'] text-[20px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['SegoeUIThis_Regular'] text-[14px] text-left leading-[120%]",
      },
    },
  },
}

export default indexfm
